import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  wrapper: {
    flex: 1,
    paddingTop: 40,
    width: '95%',
    alignSelf: 'center',
  },
  cardWrapper: theme => ({
    alignItems: 'center',
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 6,
    shadowOpacity: 1,
    elevation: 2,
    paddingHorizontal: 20,
    paddingTop: 10,
    paddingBottom: 20
  }),
  contentContainerStyle: withTray => ({
    paddingBottom: withTray ? 120 : 30,
    paddingHorizontal: '10%'
  }),
});
